import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className='flex flex-col items-center justify-center h-screen bg-gray-100'>
      <h1 className='text-7xl font-bold text-gray-800'>404</h1>
      <p className='text-2xl text-gray-600 mt-4'>Oops! Page not found.</p>
      <p className='text-gray-500 mt-2'>
        The page you are looking for might have been removed or doesn't exist.
      </p>
      <Link
        to='/'
        className='mt-6 px-6 py-3 bg-prime text-white rounded-lg shadow transition'
      >
        Go Home
      </Link>
    </div>
  )
}

export default NotFound
